export default "__VITE_PUBLIC_ASSET__062b7420__"